const scrollWithOffset = (el, offset) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset
  window.scrollTo({ top: yCoordinate + offset, behavior: 'smooth' })
}

export default scrollWithOffset
